import { gql } from '@apollo/client';

export default gql`
  fragment ProjectCollaboratorGroupFields on ProjectCollaboratorGroup {
    id
    createdAt
    updatedAt
    isApproved
    __typename
  }
`;
